import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { store } from '../../index'
import { Icon } from 'components'

export default class Modal extends React.Component {
  componentDidMount() {
    this.modalTarget = document.createElement('div')
    this.modalTarget.className = 'modal'
    document.body.appendChild(this.modalTarget)
    this.renderModal()
  }

  componentWillUpdate() {
    this.renderModal()
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this.modalTarget)
    document.body.removeChild(this.modalTarget)
  }

  renderModal() {
    ReactDOM.render(
      <Provider store={store}>
        <div>
          <div className="modal__box">
            <div className="modal__box--title">
              <h4>{this.props.title}</h4>
              <Icon
                name="cancel-black"
                small
                onClick={() => this.props.handleClose()}
              />
            </div>
            <div className="modal__box--content">{this.props.children}</div>
          </div>
        </div>
      </Provider>,
      this.modalTarget
    )
  }

  render() {
    return <noscript />
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Modal.js